import {
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    AfterViewInit,
    Output,
    Inject,
    forwardRef,
    HostListener,
    Input,
    EventEmitter
} from '@angular/core';

import BpmnInit from './BpmnInit';
import BpmnFormHelper from './BpmnFormHelper';
import BpmnApiHelper from './BpmnApiHelper';
import BpmnConfig from './BpmnConfig';
//import propertiesPanelModule from 'bpmn-js-properties-panel';
//import propertiesProviderModule from 'bpmn-js-properties-panel/lib/provider/camunda';
import {HttpClient} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

declare let $;
// @ts-ignore
//import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda.json';
import {ConfService} from '../../conf.service';
import {FormControl} from '@angular/forms';
import {ICategory} from '../../crudapi/crudapi.component';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {KongService} from '../../kong.service';
import {HeadersComponent} from '../../devex/headers/headers.component';
import {AuthorizationComponent} from '../../authorization/authorization.component';
import {DialogComponent} from '../../shared/dialog/dialog.component';
import {ListenerService} from '../../listener.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {ApigatewayListenerService} from '../../apigateway-listener.service';
import {EntityVersionChangeConfirmationComponent} from '../../edit-entity/edit-entity.component';
import {BusinesslogicListenerService} from '../../businesslogic-listener.service';
import {WorkflowListenerService} from '../../workflow-listener.service';
import {ImportBpmnDialogComponent} from '../import-bpmn-dialog/import-bpmn-dialog.component';
import {WebsocketService} from '../../websocket.service';
import {CamundaviewerComponent} from '../camundaviewer/camundaviewer.component';
import {TestCaseData} from '../../testcase/testcase.component';
import {error} from 'selenium-webdriver';
import {DependencyCheckComponent} from '../../new-blockly/new-blockly.component';
import {TestReportComponent} from '../../testsuite/test-report/test-report.component';
import Modeler from 'bpmn-js/lib/Modeler';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import { Orientation, TourStep } from 'ngx-guided-tour';
// import { BreakpointObserver } from '@angular/cdk/layout';
// import { delay, filter } from 'rxjs/operators';
// import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';


class ImageSnippet {
    constructor(public src: string, public file: File) {
    }
}

const incr = 5;

@Component({
    selector: 'app-workfloweditor',
    templateUrl: './workfloweditor.component.html',
    styleUrls: ['./workfloweditor.component.scss']
})
export class WorkfloweditorComponent implements AfterViewInit, OnInit {
    @ViewChild(HeadersComponent) devexHeader: HeadersComponent;

    serviceTaskConfig: any;
    bpmnForm: any;

    showNextPanel = false;
    xmlData: any;
    deploymentName: any;
    xmlDataToSend: any;
    deploymentSource: any;
    bpmnVariables: any;
    executor_name: string;
    selectedVersion: string;
    selectedExecutor: string;
    selectedExecutorType = 'WORKFLOW';
    executorMethods = [
        {name: 'GET'},
        {name: 'POST'},
        {name: 'PUT'},
        {name: 'DELETE'}
    ];
    executorTypes = [
        // {'displayName': 'Simple API', 'value': 'API'},
        // {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'},
        {'displayName': 'Workflow API', 'value': 'WORKFLOW'},
        // {'displayName': 'Data Access API', 'value': 'DATAACCESS'},
        // {'displayName': 'Third Party API', 'value': 'THIRDPARTY'}
    ];
    myControl = new FormControl();

    executorCategory: string;
    filteredOptions: Observable<ICategory[]>;
    editFlag: boolean;
    Blocks = [];
    @Input() partner = localStorage.getItem('partner');
    partnerKey = localStorage.getItem('partnerKey');
    @Input() account_id = localStorage.getItem('account');
    apiKey = localStorage.getItem('apikey');
    url = environment.konghost;
    gatewayFullUrl: string;
    gatewayUrl: any;
    executor_display_name: string;
    scopeSelected = 'public';
    description: string;
    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    save: boolean;
    authModel = {
        'authType': '',
        'authAttributes': {}
    };
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;

    headers = [];
    @Input() mockResponses = [];
    queryParams = [];
    requestBody = {};
    prerequisites: any;
    responseAttributes = [];
    attributeList = [];
    executor: any;
    isDesigner: boolean;
    progress = 0;
    servicedata: any;
    routehostdata: any;
    routepathdata: any;
    ratelimitingOrig: any;
    keyauthOrig: any;
    ipRestrictionOrig: any;
    cors: any;
    acl: any;
    destroy: any;
    progressMessage: string;
    @Input() entity: string;
    @Input() version: string;
    @Input() showButtons = true;
    @Input() executorModelAvailable = false;
    @Input() executorModelInput: any;

    @Output() onSavingExecutor: EventEmitter<any> = new EventEmitter<any>();
    camundaApiURL: string;

    showParameterMapping: boolean;
    inputParameters: any;
    outputParameters: any;
    sourceId: any;
    sourceName: any;
    targetId: any;
    targetName: any;
    @Input() isApiDiscovery: boolean;
    result: any;
    //
    selectedFile: ImageSnippet;
    @Output() isExecute: boolean;
    // saveXml: any;
    xmlOutput: any;
    loading1 = false;
    // xx: any;
    @ViewChild('canvas')
        // @ViewChild(BpmnComponent) bpmncom: BpmnComponent;
        // @ViewChild(forwardRef(() => BpmnComponent))
        // private bpmncom: BpmnComponent;
    cloneable = false;
    isAPIHistory = false;
    isToggleExpanded = false;

    isAPIAlreadyPresent: boolean;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    editable_executor_name: any;
    editable_executor_version: any;

    orig_executor: any;
    orig_executor_name: any;
    orig_executor_version: any;

    previousSavedData: any;
    logVisible = false;
    refreshLogCount = 0;
    logComponentRefresh = false;
    apiDeploymentLogs = [];
    currentMessage: any;
    apiType = 'WORKFLOW';
    logTimeStamp: any;
    action: any;
    connection: any;
    showDialogOnNonWebsocketConnection: any;
    apiName: any;
    s3Files: any;

    dependencyApis: any;
    testLoading = false;
    testSuiteResponse: any;
    platformServiceProviders: any;
    showFiller = true;
    showFillerForServiceTaskDialog = true;
    serviceProviderSearchText = '';
    apiList: any;


    selections = [{
        value: 1
    },{
        value: 2
    },{
        value: 3
    }];

    apiSearchInputCrtl = new FormControl();

    private canvesRef: ElementRef;

    constructor(public platform: LeftpanelComponent, private router: Router, public dialog: MatDialog, private http: HttpClient, private confPost: ConfService, private _route: ActivatedRoute,
                private cfgSrv: ConfService, private leftPanelDataListener: ListenerService, private kongService: KongService, private workflowListenerInstance: WorkflowListenerService, private websocketService: WebsocketService
    ) {
        this.serviceTaskConfig = BpmnInit;
        this.bpmnForm = BpmnFormHelper;
        BpmnConfig.setConfService(cfgSrv);
        this._route.queryParams
            .subscribe(params => {
                if (params.clone) {
                    this.cloneable = true;
                    const exec = this.platform.cloneableData;
                    if (exec) {
                        this.setExecutor(exec);
                        //this.modeler.importXML(exec['source'], value => this.handleError(value));
                    } else {
                        this.router.navigateByUrl('/workflow');
                    }
                } else if (params.timestamp && params.timestamp !== null && params.timestamp !== undefined && params.timestamp !== '') {
                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partner + '&account=' + this.account_id + '&at=' + params.timestamp).subscribe(response => {
                        if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
                            const exec = response[0]['executor'];
                            this.setExecutor(exec);
                            if (response[0]['action'] === 'CREATE') {
                                this.editFlag = false;
                            } else {
                                this.editFlag = true;
                            }
                        }
                    });
                } else if (params.entity && params.version) {
                    this.entity = params.entity;
                    this.version = params.version;
                    this.editFlag = true;
                    this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(exec => {
                        this.setExecutor(exec);
                        this.orig_executor = exec;
                        this.orig_executor_name = exec['executor_name'];
                        this.orig_executor_version = exec['executor_version'];
                        //this.modeler.importXML(exec['source'], value => this.handleError(value));
                    });
                } else {
                    this.selectedExecutorType = 'WORKFLOW';
                    // BpmnInit.createNewDiagram();
                    this.editFlag = false;
                    this.cloneable = false;
                    this.isAPIHistory = false;
                    this.executor_name = undefined;
                    this.selectedVersion = undefined;
                    this.executor_display_name = undefined;
                    this.description = undefined;
                    this.executorCategory = undefined;
                    this.scopeSelected = 'public';
                    this.selectedExecutor = undefined;
                    this.queryParams = [];
                    this.headers = [];
                    this.mockResponses = [];
                    this.requestBody = [];
                    this.attributeList = [];
                }
            });

        this.leftPanelDataListener.notifyWorkflowBuilder.subscribe(apiName => {
            this.apiName = apiName;
        });
        this.leftPanelDataListener.assignAPIToTask.subscribe(response => {
            if (response) {
                BpmnInit.closeDialog('registerAPI');
                BpmnInit.closeDialog('createDataAccessAPI');
                BpmnInit.closeDialog('createBusinessLogicAPI');
                BpmnInit.closeDialog('createSQLQueryAPI');
                if (this.apiName && this.apiName !== '') {
                    BpmnInit.refreshAPIs(this.apiName);
                    this.apiName = '';
                }
            }
        });
    }

    // show(){
    //     this.showModalDAAS = true;
    // }

    hideParameterMapping() {
        this.showParameterMapping = false;
        localStorage.setItem('inputMapping', JSON.stringify(this.result));
    }

    setExecutor(exec) {
        this.selectedExecutorType = exec['executor_type'];
        this.executor_name = exec['executor_name'];
        this.selectedVersion = exec['executor_version'];
        this.executor_display_name = exec['executor_display_name'];
        this.description = exec['executor_description'];
        this.executorCategory = exec['executor_category'];
        this.scopeSelected = exec.scopeOfAccess ? exec.scopeOfAccess : exec.executor_scope;
        this.selectedExecutor = exec['executor_method_type'];
        this.queryParams = exec['queryParams'];
        this.headers = exec['headers'];
        this.mockResponses = exec['mockResponses'];
        this.authModel = exec['authModel'];
        this.requestBody = exec['requestBody'];
        BpmnInit.initialised = false;
        BpmnInit.createNewDiagram(exec['source']);
    }

    ngAfterViewInit() {
        // this.observer
        //     .observe(['(max-width: 800px)'])
        //     .pipe(delay(1), untilDestroyed(this))
        //     .subscribe((res) => {
        //         if (res.matches) {
        //             // this.sidenav.mode = 'over';
        //             // this.sidenav.close();
        //             this.showFiller = false;
        //         } else {
        //             // this.sidenav.mode = 'side';
        //             // this.sidenav.open();
        //             this.showFiller = true;
        //         }
        //     });
        this.isExecute = false;
        //this.logger.info("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXloading 12 ngAfterViewInit() method");  // this is called initially
        //BpmnInit.init();
        if (this.isApiDiscovery && this.entity !== undefined && this.version !== undefined) {
            this.editFlag = true;
            this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(exec => {
                this.setExecutor(exec);
                this.orig_executor = exec;
                this.orig_executor_name = exec['executor_name'];
                this.orig_executor_version = exec['executor_version'];
                //this.modeler.importXML(exec['source'], value => this.handleError(value));
            });
        }
        if (!this.isApiDiscovery) {
            this._route.queryParams
                .subscribe(params => {
                    if (params.clone) {
                        this.cloneable = true;
                    } else {
                        this.entity = params.entity;
                        this.version = params.version;
                    }
                });
        }

    }

    async copyTo() {
        if (this.orig_executor) {
            const metaSchema = JSON.parse(JSON.stringify(this.orig_executor));
            this.platform.copyToPartner(this.orig_executor['executor_name'], this.orig_executor['executor_version'], 'WORKFLOW', metaSchema);
        }
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.requestBody = {
            'value': {
                'variables': {'payloadx': {'value': '', 'type': 'String'}, 'anotherVariable': {'value': true, 'type': 'Boolean'}},
                'businessKey': 'myBusinessKey',
                'withVariablesInReturn': true
            },
            'key': 'payload',
            'description': 'Document in JSON format',
            'annotation': 'RequestBody'
        };
        this.headers = [{'key': 'Content-Type', 'value': 'application/json', 'description': '', 'req': false}];
        this.isDesigner = true;
        // this.getXML();
        this.showNextPanel = false;
        // this.executor_name = 'demooo';
        // this.selectedVersion = 'asda';
        this.attributeList.push(['Select Target Attributes', 'null']);
        this.save = false;
        // this.gatewayUrl = (this.partner === this.account_id ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account_id + '.apiplatform.io');
        this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        this.gatewayFullUrl = 'https://' + this.gatewayUrl;

        if (!this.isApiDiscovery) {
            this._route.queryParams
                .subscribe(params => {
                    if (params.clone) {
                        this.cloneable = true;
                    } else {
                        this.entity = params.entity;
                        this.version = params.version;
                    }
                });
        }
        if (this.executorModelAvailable) {
            this.setExecutor(this.executorModelInput);
        }
        this.platform.setGuideTourSteps(this.getWorkflowTourSteps());
        this.getS3Files();
        this.getServiceProviders();
    }

    getServiceProviders() {
        // this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services' + '&account=services').subscribe(platformProviders => {
        //     this.platformServiceProviders = platformProviders;
        //     console.log(this.platformServiceProviders);
        //     this.platform.platformServiceProviders = platformProviders;
        // });
        this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(settingsData => {
            let tempSettingsData: any;
            tempSettingsData = settingsData;
            this.platform.settingsData = settingsData;
            //this.flag2 = true;
            if (this.partner !== 'services') {
                if (tempSettingsData['body'][0]) {
                    this.platformServiceProviders = tempSettingsData['body'][0]['subscriptions']['providers'];
                    //let flag = false;
                }
            }
        }, error => {
            this.platform.openSnackBar('Error while fetching subscribed service providers', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getS3Files() {
        this.confPost.getS3Files(this.partner).subscribe((data) => {
            this.s3Files = data;
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while retrieving files from S3');
        });
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.websocketService.isOpen()) {
            // that.setInterval(blockEnd, true);
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    listenAPICreation(timestamp, apiName, apiVersion, action) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, action).subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    getExecutor() {
        this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(exec => {
            //this.setExecutor(exec);
            this.orig_executor = exec;
            this.orig_executor_name = exec['executor_name'];
            this.orig_executor_version = exec['executor_version'];
            //this.modeler.importXML(exec['source'], value => this.handleError(value));
        });
    }

    designer() {
        // this.bpmncom.designer();
        this.isDesigner = true;
    }

    output() {
        this.isDesigner = false;
        // this.bpmncom.output();
    }

    blankDiagram() {
        BpmnInit.createNewDiagram();
    }

    initDownloadButton() {
        BpmnInit.initDownloadButtons();
    }

    processFileAuto(event: any) {
        //console.log('process file auto', event);
        let target = event.target;
        this.processFile(target);
    }

    processFile(imageInput: any) {
        // const file: File = imageInput.files[0];
        const file: File = imageInput;
        const reader = new FileReader();
        // this.modeler.importXML(file, value => this.handleError(value));
        reader.addEventListener('load', (event: any) => {

            this.selectedFile = new ImageSnippet(event.target.result, file);
            this.load(this.selectedFile['src']);
            this.confPost.uploadS3FileForBPMN(localStorage.getItem('account'), '', localStorage.getItem('partner'), this.selectedFile.file, '').subscribe(
                (res) => {
                    this.platform.openSnackBar('Imported Successfully!', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });

                    // this.modeler.importXML(this.selectedFile.file, value => this.handleError(value));
                    // this.load(this.selectedFile.file);
                },
                (err) => {
                    this.platform.openSnackBar('Error occured while import, Please try after sometime', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        });
        reader.readAsDataURL(file);
    }

    load(urlToLoad) {
        this.getExample(urlToLoad).subscribe(data => {
            //this.logger.info("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXloading 11 cloneable() method");
            //console.log('createNewDiagram in load url', urlToLoad);
            BpmnInit.createNewDiagram(data);
            setTimeout(() => {
                const modeler = BpmnInit.bpmnModeler;
                const elementRegistry = modeler.get('elementRegistry');
                const elements = elementRegistry.filter(function (element) {
                    return is(element, 'bpmn:ServiceTask');
                });
                if (elements && elements.length) {
                    for (const element of elements) {
                        const overlays = modeler.get('overlays');
                        const image = element.businessObject.logo ? element.businessObject.logo : '';
                        const id = element.businessObject.id;
                        if (image && image !== '') {
                            overlays.add(element, {
                                html: `<div lass="img-overlay">
                <img id="${id}" height="40" width="70" src="${image}">
              </div>`,
                                position: {
                                    left: -5,
                                    top: -45
                                }
                            });
                        }
                    }
                }
            }, 3000);

            // this.modeler.importXML(data, value => this.handleError(value));
        });
    }

    load1() {
        // // const urlToLoad = prompt('Please enter s3 Path', '');
        // // const urlToLoadTemp = '/assets/' + urlToLoad;
        // this.cfgSrv.getApiExecutorsForThirdPartnerAccount('b2b', 'b2b')
        //     .toPromise().then(data1 => {
        //   return data1;
        // });
        // const urlToLoadTemp = 'https://s3.ap-south-1.amazonaws.com/gateway.saldin.apiplatform.io/payment.bpmn';
        // this.getExample(urlToLoadTemp).subscribe(data => {
        //   this.modeler.importXML(data, value => this.handleError(value));
        // });

    }

    saveXML() {
        //console.log('in SaveXML');
        // this.modeler.saveXML((err: any, xml: any) => this.xx =xml);
        // this.modeler.saveXML((err: any, xml: any) => this.convertToString(xml));


    }

    getXML() {
        //console.log('in getXML');
        let xml_data = BpmnInit.saveXml();
        return xml_data;

    }

    // convertToString(xml) {
    //     let parser = new DOMParser();
    //     let xmlDoc = parser.parseFromString(xml, 'text/xml');
    // }
    handleError(err: any) {
        if (err) {
        }
    }

    CheckForExistingEntityOrExecutor() {
        return new Promise(async (resolve, reject) => {
            await Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.executor_name, this.selectedVersion)).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.executor_name;
                this.previouslyCheckedVersion = this.selectedVersion;
                if (this.loading1) {
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for API existence',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, this.logTimeStamp, this.action);
                    resolve('success');
                }
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.executor_name;
                        this.previouslyCheckedVersion = this.selectedVersion;
                        resolve('failed');
                        if (this.loading1) {
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                info: 'Checking for API existence',
                                type: 'fatal',
                                description: 'An API with the provided name and version already exists.',
                                icon: 'fa fa-newspaper-o'
                            }, this.logTimeStamp, this.action);
                        }
                        if (!this.connection) {
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.executor_name;
                        this.previouslyCheckedVersion = this.selectedVersion;
                        resolve('failed');
                        if (this.loading1) {
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                info: 'Checking for API existence',
                                type: 'fatal',
                                description: 'Error occurred while checking your existing API information. Please try again after sometime.',
                                icon: 'fa fa-newspaper-o'
                            }, this.logTimeStamp, this.action);
                        }
                        if (!this.connection) {
                            this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
                if (this.loading1) {
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for API existence',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o'
                    }, this.logTimeStamp, this.action);
                }
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.editFlag === true) {
                            if (this.executor_name !== this.orig_executor_name || this.selectedVersion !== this.orig_executor_version) {
                                if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                                    this.isAPIAlreadyPresentCheckCompleted = true;
                                    await this.CheckForExistingEntityOrExecutor();
                                    resolve('success');
                                } else {
                                    if (this.loading1) {
                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                            info: 'Checking for API existence',
                                            type: 'success',
                                            icon: 'fa fa-newspaper-o'
                                        }, this.logTimeStamp, this.action);
                                    }
                                    resolve('success');
                                }
                            } else {
                                if (this.loading1) {
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                        info: 'Checking for API existence',
                                        type: 'success',
                                        icon: 'fa fa-newspaper-o'
                                    }, this.logTimeStamp, this.action);
                                }
                                resolve('success');
                            }
                        } else {
                            if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion) {
                                this.isAPIAlreadyPresentCheckCompleted = true;
                                await this.CheckForExistingEntityOrExecutor();
                                resolve('success');
                            } else {
                                if (this.loading1) {
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                        info: 'Checking for API existence',
                                        type: 'success',
                                        icon: 'fa fa-newspaper-o'
                                    }, this.logTimeStamp, this.action);
                                }
                                resolve('success');
                            }
                        }
                    } else {
                        this.isAPIAlreadyPresentCheckCompleted = true;
                        await this.CheckForExistingEntityOrExecutor();
                        resolve('success');
                    }
                } else {
                    if (this.loading1) {
                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                            info: 'Checking for API existence',
                            type: 'success',
                            icon: 'fa fa-newspaper-o'
                        }, this.logTimeStamp, this.action);
                    }
                    resolve('success');
                }
            }
        });
    }

    checkForExistingEntityAndExecutorFromFocusOut() {
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 2000);
    }

    getExample(urlToLoad) {
        const url = urlToLoad; // local
        // https://s3.ap-south-1.amazonaws.com/gateway.saldin.apiplatform.io/payment.bpmn
        return this.http.get(url, {responseType: 'text'});
        // return this.http.get(url);
    }

    emitApi() {
        let xml_text1: any;
        if (BpmnInit.bpmnModeler) {
            xml_text1 = BpmnInit.saveXml();
            if (this.executor_name && this.selectedVersion && this.selectedExecutor && this.executorCategory) {
                xml_text1.then(xml_text => {
                    //console.log('in generate excutor - save xml is ', xml_text);
                    this.requestBody = this.devexHeader.getRequestBody();
                    const fabResult = {
                        'executor_type': this.selectedExecutorType,
                        'executor_name': this.executor_name,
                        'executor_version': this.selectedVersion,
                        'executor_display_name': this.executor_display_name,
                        'executor_description': this.description,
                        'executor_category': this.executorCategory,
                        'executor_method_type': this.selectedExecutor,
                        'published': true,
                        'scopeOfAccess': this.scopeSelected,
                        'creationTime': Date.now(),
                        'lastModifiedTime': Date.now(),
                        'registeredAsIs': false,
                        'queryParams': this.queryParams,
                        'headers': this.headers,
                        'mockResponses': this.mockResponses,
                        'requestBody': this.requestBody,
                        'prerequisites': this.prerequisites,
                        'source': xml_text,
                        // 'executors': executors,
                        'executors': undefined,
                        'partner': this.partner,
                        'account_id': this.account_id,
                        'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
                        // 'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partner + '/' + this.account + '/' + this.executor_name,
                        'dataroot': null,
                        'responseAttributes': null,
                        'attributeMappings': null,
                        'response': null,
                        'block_attributes': this.attributeList
                    };
                    fabResult['authModel'] = this.devexHeader.authModel1.getAuthModel();
                    this.onSavingExecutor.emit(fabResult);
                });
            } else {
                this.platform.openSnackBar('Please enter all the required fields.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }
    }

    execute() {
        this.bpmnVariables = this.devexHeader.getRequestBody();
        this.bpmnVariables = this.bpmnVariables.value;
        // let xml_data = BpmnInit.saveXml();//let xml_data = '';
        //this.modeler.saveXML({ format: true }, function(err, xml) {
        //    xml_data = xml;
        //});
        const xml_text1 = BpmnInit.saveXml();
        xml_text1.then(xml_text => {
            this.xmlDataToSend = xml_text;
            if (this.executor_name !== undefined && this.selectedVersion !== undefined && this.selectedVersion !== '' && this.executor_name !== '') {
                this.deploymentName = localStorage.getItem('partner') + '_' + localStorage.getItem('account') + '_' + this.executor_name + '_' + this.selectedVersion;
                this.deploymentSource = localStorage.getItem('partner') + '_' + localStorage.getItem('account') + '_' + this.executor_name + '_' + this.selectedVersion;
            } else {
                this.deploymentName = localStorage.getItem('partner') + '_' + localStorage.getItem('account') + 'workflow';
                this.deploymentSource = localStorage.getItem('partner') + '_' + localStorage.getItem('account') + 'workflow';
            }
            this.isExecute = true;
            this.isDesigner = false;
            $('.djs-palette').addClass('two-column');
            $('.canvas').addClass('dock');
            $('.properties-panel-parent').addClass('dock');
            $('.djs-palette').addClass('dock-tools');
            // const dialogRef = this.dialog.open(CamundaviewerComponent, {
            //     data: {
            //         bpmnVariables: this.bpmnVariables,
            //         deploymentName: this.deploymentName,
            //         deploymentSource: this.deploymentSource,
            //         xmlDataToSend: this.xmlDataToSend
            //     },
            //     height: '80%',
            //     width: '80%'
            // });
        });
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    async saveAPI() {

        const saveClickedMessage = this.editFlag === true ? 'workflow_edit_save_clicked' : 'workflow_create_save_clicked';
        const saveSuccessMessage = this.editFlag === true ? 'workflow_edit_save_success' : 'workflow_create_save_success';
        const saveFailureMessage = this.editFlag === true ? 'workflow_edit_save_failed' : 'workflow_create_save_failed';

        const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
        };

        savePayload.partner = this.partner;
        savePayload.account = this.account_id;
        savePayload['at'] = Date.now();
        savePayload.by = this.partner;
        savePayload.executor_name = this.executor_name ? this.executor_name : Date.now().toString();
        savePayload.executor_version = this.selectedVersion;
        savePayload.executor_type = this.selectedExecutor;
        if (this.editFlag) {
            savePayload.action = 'UPDATE';
        } else {
            savePayload.action = 'CREATE';
        }

        savePayload.executor_type = 'WORKFLOW';

        const xml_text1 = BpmnInit.saveXml();
        xml_text1.then(xml_text => {
            const fabResult = {
                'executor_type': this.selectedExecutorType,
                'executor_name': this.executor_name,
                'executor_version': this.selectedVersion,
                'executor_display_name': this.executor_display_name,
                'executor_description': this.description,
                'executor_category': this.executorCategory,
                'scopeOfAccess': this.scopeSelected,
                'executor_method_type': this.selectedExecutor,
                'dataroot': null,
                'queryParams': this.queryParams,
                'headers': this.headers,
                'mockResponses': this.mockResponses,
                'requestBody': this.requestBody,
                'prerequisites': this.prerequisites,
                'source': xml_text,
                // 'executors': executors,
                'executors': undefined,
                'partner': this.partner,
                'account_id': this.account_id,
                'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
                // 'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partner + '/' + this.account + '/' + this.executor_name,
                'responseAttributes': null,
                'attributeMappings': null,
                'response': null,
                'block_attributes': this.attributeList
            };
            fabResult['authModel'] = this.devexHeader.authModel1.getAuthModel();

            savePayload['executor'] = fabResult;

            const temp = JSON.parse(JSON.stringify(savePayload['executor']));
            let isSame = true;
            if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
                if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                    const keyArray = Object.keys(this.previousSavedData);
                    for (const key of keyArray) {
                        if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                            continue;
                        } else {
                            isSame = false;
                            break;
                        }
                    }
                } else {
                    isSame = false;
                }
            } else {
                isSame = false;
            }

            if (isSame === false) {
                this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                    this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                    this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while saving the API. Please try again after sometime.');
                });
            } else {
                this.platform.openSnackBar('No changes to save for this Workflow API', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        });
    }

    saveDiagramToS3() {
        if (BpmnInit.initialised) {
            const dialogRef = this.dialog.open(ExportBpmnToS3Component, {
                data: {name: ''},
                height: '25%',
                width: '30%'
            });
            dialogRef.afterClosed().subscribe(name => {
                if (name) {
                    const fileName = name + '.bpmn';
                    const xml_text1 = BpmnInit.saveXml();
                    xml_text1.then(xml_text => {
                        const blob = new Blob([xml_text], {type: '.bpmn'});
                        const file = new File([blob], fileName);
                        file['progress'] = 100;
                        this.confPost.uploadFileInS3(this.partner, file, '').subscribe((resp) => {
                            this.platform.openSnackBar('Your diagram has been saved to S3 successfully.', 'Success', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }, error1 => {
                            this.platform.handleErrorGracefully(error1, 'Error while saving your diagram to S3');
                        });
                    });
                }
            });
        }
    }

    displayServiceProviders() {
        if (BpmnInit.initialised) {
            return true;
        }
        return false;
    }

    redeployWorkflowAPI() {
        if (this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.getAPIUsagesWithTestsuites(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                this.dependencyApis = response;
                loaderDialog.close();
                const dialogRef = this.dialog.open(DependencyCheckComponent, {
                    width: '60%',
                    height: 'auto',
                    maxHeight: '70vh',
                    data: {
                        executors: this.dependencyApis,
                        executor_name: this.executor_name,
                        executor_version: this.selectedVersion
                    }
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result && result.continue) {
                        this.deployWorkflowAPI(result.mode);
                    }
                });

            }, error1 => {
                loaderDialog.close();
                this.platform.openSnackBar('Error while fetching the usages of the API. Please try again later.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.deployWorkflowAPI();
        }
    }

    async deployWorkflowAPI(testMode = 'notests') {
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;


        this.logComponentRefresh = true;

        if (this.editFlag === true) {
            this.action = 'redeploy';
        } else {
            this.action = 'deploy';
        }

        //this.loading = true;


        this.logVisible = false;
        if (this.websocketService.isOpen()) {
            this.connection = true;
            // this.logVisible = true;
        } else {
            this.connection = false;
        }

        if (this.executor_name && this.selectedVersion && this.selectedExecutor && this.executorCategory) {
            if (this.connection) {
                this.logVisible = true;
            }
            if (this.connection === false) {
                this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                    data: {
                        message: 'API deployment is under progress. Please don\'t close the window'
                    }
                });
            }
            this.listenAPICreation(timeStamp, this.executor_name, this.selectedVersion, this.action);
            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                info: 'Checking for special characters in Executor name',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, this.action);
            Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.executor_name)).then(async resp1 => {
                if (resp1 === true) {
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for special characters in Executor name',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for special characters in Executor version',
                        type: 'initial',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                    Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.selectedVersion)).then(async resp2 => {
                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                            info: 'Checking for special characters in Executor version',
                            type: 'success',
                            icon: 'fa fa-newspaper-o'
                        }, timeStamp, this.action);

                        if (this.editFlag === false) {
                            if (this.connection) {
                                this.logVisible = true;
                            }
                            if (this.isAPIAlreadyPresentCheckCompleted === false) {
                                await this.checkForExistingEntityAndExecutor();
                            }
                            if (this.isAPIAlreadyPresent === false) {
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                    info: 'Checking for API existence',
                                    type: 'initial',
                                    icon: 'fa fa-newspaper-o'
                                }, this.logTimeStamp, this.action);
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                    info: 'Checking for API existence',
                                    type: 'success',
                                    icon: 'fa fa-newspaper-o'
                                }, this.logTimeStamp, this.action);
                                this.generateExecutor();
                            } else {
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                    info: 'Checking for API existence',
                                    type: 'initial',
                                    icon: 'fa fa-newspaper-o'
                                }, this.logTimeStamp, this.action);
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                                    info: 'Checking for API existence',
                                    type: 'fatal',
                                    description: 'An API with the provided name and version already exists.',
                                    icon: 'fa fa-newspaper-o'
                                }, this.logTimeStamp, this.action);
                                this.closeNonWSDialogBox();
                            }
                        } else {
                            if (this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
                                if (this.executorCategory !== undefined && this.executorCategory !== '') {
                                    if (this.connection) {
                                        this.logVisible = true;
                                    }
                                    this.generateExecutor(testMode);
                                } else {
                                    this.closeNonWSDialogBox();
                                    this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            } else {
                                const publishdata = {};
                                let message = 'Change in entity';
                                publishdata['orig_executor_name'] = this.orig_executor_name;
                                publishdata['orig_executor_version'] = this.orig_executor_version;
                                publishdata['entity'] = this.executor_name;
                                publishdata['version'] = this.selectedVersion;
                                publishdata['tableName'] = 'workflow';
                                publishdata['origCollection'] = 'workflow';

                                if (this.orig_executor_name !== this.executor_name) {
                                    if (this.orig_executor_version !== this.selectedVersion) {
                                        message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Workflow API ?';
                                    } else {
                                        message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Workflow API ?';
                                    }
                                } else {
                                    if (this.orig_executor_version !== this.selectedVersion) {
                                        message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Workflow API ?';
                                    }
                                }
                                if (this.executor_name !== '' && this.selectedVersion !== '') {
                                    if (this.executorCategory !== undefined && this.executorCategory !== '') {
                                        this.loading1 = false;
                                        this.closeNonWSDialogBox();
                                        publishdata['message'] = message;
                                        if (this.isAPIAlreadyPresentCheckCompleted === false) {
                                            await this.checkForExistingEntityAndExecutor();
                                        }

                                        if (this.isAPIAlreadyPresent === false) {
                                            const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                                width: '60%',
                                                data: publishdata
                                            });
                                            dialogRef.afterClosed().subscribe(result => {
                                                if (result) {
                                                    // Create API
                                                    this.loading1 = true;
                                                    this.editFlag = false;
                                                    this.generateExecutor();
                                                }
                                            });
                                        } else {
                                            this.loading1 = false;
                                            this.closeNonWSDialogBox();
                                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                                duration: 5000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                        }
                                    } else {
                                        this.loading1 = false;
                                        this.closeNonWSDialogBox();
                                        this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                } else {
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                    this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            }
                        }


                    });
                } else {
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REQUIREMENTS', {
                        info: 'Checking for special characters in Executor version',
                        type: 'fatal',
                        description: 'Special characters are not allowed in Executor Version',
                        icon: 'fa fa-newspaper-o'
                    }, timeStamp, this.action);
                }
            });

        } else {
            this.platform.openSnackBar('Please fill all required fields', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    generateExecutor(testMode = 'notests') {
        const logTimeStamp = Date.now();
        this.loading1 = true;
        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DESIGN', {
            info: 'Checking for all required fields',
            type: 'initial',
            icon: 'fa fa-file-code-o'
        }, this.logTimeStamp, this.action);
        let xml_text1: any;
        if (BpmnInit.bpmnModeler) {
            xml_text1 = BpmnInit.saveXml();

            if (this.executor_name && this.selectedVersion && this.selectedExecutor && this.executorCategory) {
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DESIGN', {
                    info: 'Checking for all required fields',
                    type: 'success',
                    icon: 'fa fa-file-code-o'
                }, this.logTimeStamp, this.action);
                xml_text1.then(xml_text => {
                    //console.log('in generate excutor - save xml is ', xml_text);
                    this.requestBody = this.devexHeader.getRequestBody();
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                        info: 'Generating the API',
                        icon: 'fa fa-code',
                        type: 'initial'
                    }, this.logTimeStamp, this.action);
                    const fabResult = {
                        'executor_type': this.selectedExecutorType,
                        'executor_name': this.executor_name,
                        'executor_version': this.selectedVersion,
                        'executor_display_name': this.executor_display_name,
                        'executor_description': this.description,
                        'executor_category': this.executorCategory,
                        'executor_method_type': this.selectedExecutor,
                        'published': true,
                        'scopeOfAccess': this.scopeSelected,
                        'creationTime': Date.now(),
                        'lastModifiedTime': Date.now(),
                        'registeredAsIs': false,
                        'queryParams': this.queryParams,
                        'headers': this.headers,
                        'mockResponses': this.mockResponses,
                        'requestBody': this.requestBody,
                        'prerequisites': this.prerequisites,
                        'source': xml_text,
                        // 'executors': executors,
                        'executors': undefined,
                        'partner': this.partner,
                        'account_id': this.account_id,
                        'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
                        // 'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partner + '/' + this.account + '/' + this.executor_name,
                        'dataroot': null,
                        'responseAttributes': null,
                        'attributeMappings': null,
                        'response': null,
                        'block_attributes': this.attributeList
                    };
                    fabResult['authModel'] = this.devexHeader.authModel1.getAuthModel();
                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                        info: 'Generating process id from camunda',
                        icon: 'fa fa-code',
                        type: 'initial'
                    }, this.logTimeStamp, this.action);
                    this.cfgSrv.getProcessIdFromCamunda(this.partner, this.account_id, fabResult).subscribe(exec => {
                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                            info: 'Generating process id from camunda',
                            icon: 'fa fa-code',
                            type: 'success'
                        }, this.logTimeStamp, this.action);
                        this.camundaApiURL = 'https://camunda.apiplatform.io/engine-rest/process-definition/' + exec['processId'] + '/start';
                        fabResult['workflow_credentials'] = exec;
                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                            info: 'Generating the API',
                            icon: 'fa fa-code',
                            type: 'initial'
                        }, this.logTimeStamp, this.action);
                        this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executor_name, this.selectedVersion).subscribe(exec => {
                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                                info: 'Generating the API',
                                icon: 'fa fa-code',
                                type: 'success'
                            }, this.logTimeStamp, this.action);
                            this.executor = exec;
                            if (this.executor) {
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                    info: 'Capturing changes made in API definition',
                                    type: 'initial',
                                    icon: 'fa fa-cloud-upload'
                                }, this.logTimeStamp, this.action);
                                if (this.executor['source'] === xml_text && this.platform.checkEqualStrings(fabResult['executor_display_name'], this.orig_executor['executor_display_name']) &&
                                    this.platform.checkEqualStrings(fabResult['executor_description'], this.orig_executor['executor_description']) &&
                                    this.platform.checkEqualStrings(fabResult['executor_category'], this.orig_executor['executor_category']) &&
                                    this.platform.checkEqualStrings(fabResult['scopeOfAccess'], this.orig_executor['scopeOfAccess']) &&
                                    this.platform.checkEqualStrings(fabResult['executor_method_type'], this.orig_executor['executor_method_type']) &&
                                    this.platform.checkEqualStrings(fabResult['dataroot'], this.orig_executor['dataroot']) &&
                                    this.platform.checkEquality(fabResult['prerequisites'], this.orig_executor['prerequisites']) &&
                                    this.platform.checkEquality(fabResult['responseAttributes'], this.orig_executor['responseAttributes']) &&
                                    this.platform.checkEquality(fabResult['response'], this.orig_executor['response']) &&
                                    this.platform.checkEquality(fabResult['executors'], this.orig_executor['executors']) &&
                                    this.platform.checkEquality(fabResult['attributeMappings'], this.orig_executor['attributeMappings']) &&
                                    this.platform.checkEquality(fabResult['pathParams'], this.orig_executor['pathParams']) &&
                                    this.platform.checkEquality(fabResult['queryParams'], this.orig_executor['queryParams']) &&
                                    this.platform.checkEquality(fabResult['headers'], this.orig_executor['headers']) &&
                                    this.platform.checkEquality(fabResult['mockResponses'], this.orig_executor['mockResponses']) &&
                                    this.platform.checkEquality(fabResult['authModel'], this.orig_executor['authModel']) &&
                                    this.platform.checkEquality(fabResult['requestBody'], this.orig_executor['requestBody'])) {
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                        info: 'Capturing changes made in API definition',
                                        type: 'fatal',
                                        description: 'No changes to save for this Workflow  API.',
                                        icon: 'fa fa-cloud-upload'
                                    }, this.logTimeStamp, this.action);
                                    this.closeNonWSDialogBox();
                                    this.loading1 = false;
                                } else {
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                        info: 'Capturing changes made in API definition',
                                        type: 'success',
                                        icon: 'fa fa-cloud-upload'
                                    }, this.logTimeStamp, this.action);
                                    fabResult['creationTime'] = exec['creationTime'];
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                        info: 'Updating API Executor',
                                        type: 'initial',
                                        icon: 'fa fa-cloud-upload'
                                    }, this.logTimeStamp, this.action);
                                    this.cfgSrv.updateApiExecutorForPartnerAccount(this.partner, this.account_id, exec['id'], fabResult).subscribe(async data => {
                                        // this.loading1 = false;
                                        // this.closeNonWSDialogBox();
                                        // this.save = true;
                                        // this.Blocks = [1, 2, 4];
                                        // const blockLength = this.Blocks.length;
                                        // const blockStart = this.BlockList[this.Blocks[0]];
                                        // const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                        // this.progress = blockStart;
                                        // this.setInterval(blockEnd, true);
                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                            info: 'Updating Gateway Settings for the API',
                                            type: 'initial',
                                            icon: 'fa fa-shield'
                                        }, this.logTimeStamp, this.action);
                                        await this.kongService.updateRouteWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, [this.selectedExecutor], this.logTimeStamp, this.action);
                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                                            info: 'Updating Gateway Settings for the API',
                                            type: 'success',
                                            icon: 'fa fa-shield'
                                        }, this.logTimeStamp, this.action);
                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                            info: 'Updating API Executor',
                                            type: 'success',
                                            icon: 'fa fa-cloud-upload'
                                        }, this.logTimeStamp, this.action);

                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                            info: 'Redeploying API',
                                            type: 'initial',
                                            icon: 'fa fa-cloud-upload'
                                        }, this.logTimeStamp, this.action);
                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                            info: 'Redeploying API',
                                            type: 'success',
                                            icon: 'fa fa-cloud-upload'
                                        }, this.logTimeStamp, this.action);


                                        if (testMode === 'alltests') {
                                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'initial',
                                                messageType: 'test-results'
                                            }, this.logTimeStamp, this.action);
                                            this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(async response => {
                                                let suiteResponse: any;
                                                suiteResponse = response;

                                                if (suiteResponse.testsPassRate === 100) {
                                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'success',
                                                        messageType: 'test-results',
                                                        description: 'Test Suite pass rate: 100%',
                                                        data: {testResultId: suiteResponse['resultsId']}
                                                    }, this.logTimeStamp, this.action);
                                                    await this.finishAPIDeployment(this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                                } else {
                                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'warning',
                                                        description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                        messageType: 'test-results',
                                                        data: {testResultId: suiteResponse['resultsId']}
                                                    }, this.logTimeStamp, this.action);
                                                    await this.revertExecutorChanges(this.executor, this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                                }
                                            }, async error1 => {
                                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                    info: 'Executing test-suites for API usages',
                                                    icon: 'fa fa-check-square-o',
                                                    type: 'error',
                                                    messageType: 'test-results',
                                                    description: 'Testsuite execution failed. Please try again.'
                                                }, this.logTimeStamp, this.action);
                                                await this.revertExecutorChanges(this.executor, this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                            });

                                        } else if (testMode === 'force') {
                                            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                info: 'Executing test-suites for API usages',
                                                icon: 'fa fa-check-square-o',
                                                type: 'initial'
                                            }, this.logTimeStamp, this.action);
                                            this.confPost.getAPITestSuiteResult(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(async response => {
                                                let suiteResponse: any;
                                                suiteResponse = response;

                                                if (suiteResponse.testsPassRate === 100) {
                                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'success',
                                                        messageType: 'test-results',
                                                        description: 'Test Suite pass rate: 100%',
                                                        data: {testResultId: suiteResponse['resultsId']}
                                                    }, this.logTimeStamp, this.action);
                                                    await this.finishAPIDeployment(this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                                } else {
                                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                        info: 'Executing test-suites for API usages',
                                                        icon: 'fa fa-check-square-o',
                                                        type: 'warning-low',
                                                        description: 'Expected Test Suite Pass rate: 100%. Actual pass rate: ' + suiteResponse['testsPassRate'] + '%',
                                                        messageType: 'test-results',
                                                        data: {testResultId: suiteResponse['resultsId']}
                                                    }, this.logTimeStamp, this.action);
                                                    await this.finishAPIDeployment(this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                                }

                                            }, async error1 => {
                                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, environment.pubsubtitles.API_TESTING, {
                                                    info: 'Executing test-suites for API usages',
                                                    icon: 'fa fa-check-square-o',
                                                    type: 'error',
                                                    description: 'Testsuite execution failed. Please try again.'
                                                }, this.logTimeStamp, this.action);
                                                await this.finishAPIDeployment(this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                            });
                                        } else {
                                            this.finishAPIDeployment(this.executor_name, this.selectedVersion, this.action, this.logTimeStamp);
                                        }

                                        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                        //     info: 'Regenerating Documentation',
                                        //     type: 'initial',
                                        //     icon: 'fa fa-book'
                                        // }, this.logTimeStamp, this.action);
                                        // await this.platform.delay(1000);
                                        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                        //     info: 'Regenerating Documentation',
                                        //     type: 'success',
                                        //     icon: 'fa fa-book'
                                        // }, this.logTimeStamp, this.action);
                                        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API TESTING', {
                                        //     info: 'Checking for testcases <br>Testcases found: 0',
                                        //     icon: 'fa fa-check-square-o',
                                        //     type: 'initial'
                                        // }, this.logTimeStamp, this.action);
                                        // await this.platform.delay(1000);
                                        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API TESTING', {
                                        //     info: 'Checking for testcases <br>Testcases found: 0',
                                        //     icon: 'fa fa-check-square-o',
                                        //     type: 'success'
                                        // }, this.logTimeStamp, this.action);
                                        // await this.platform.delay(2000);
                                        // this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'DONE', {
                                        //     info: '',
                                        //     type: 'success',
                                        //     icon: 'fa fa-check'
                                        // }, this.logTimeStamp, this.action);
                                        // this.editFlag = true;
                                        // this.entity = this.executor_name;
                                        // this.version = this.selectedVersion;
                                        // this.getExecutor();
                                        // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                    }, error1 => {
                                        this.loading1 = false;
                                        this.closeNonWSDialogBox();
                                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API REDEPLOYMENT', {
                                            info: 'Updating API Executor',
                                            type: 'fatal',
                                            description: error1 && error1.message ? error1.message : 'Error while updating the API',
                                            icon: 'fa fa-cloud-upload'
                                        }, this.logTimeStamp, this.action);
                                    });

                                    // this.cfgSrv.deleteApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(deleted => {
                                    //     if (deleted) {
                                    //         this.cfgSrv.insertApiExecutorForPartnerAccount(this.partner, this.account_id, fabResult).subscribe(result => {
                                    //
                                    //         });
                                    //     }
                                    // });
                                }
                            } else {

                            }
                        }, errorExecutor => {
                            if (errorExecutor.status === 404) {
                                this.cfgSrv.insertApiExecutorForPartnerAccount(this.partner, this.account_id, fabResult).subscribe(async data => {
                                    this.platform.createAPIAuditLog(this.partner, this.account_id, fabResult['executor_name'], fabResult['executor_version'], 'WORKFLOW', fabResult);
                                    // this.Blocks = [1, 2, 4, 5];
                                    // const blockLength = this.Blocks.length;
                                    // const blockStart = this.BlockList[this.Blocks[0]];
                                    // const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                    // this.progress = blockStart;
                                    // this.setInterval(blockEnd, true);
                                    this.leftPanelDataListener.changeInLeftPanelDataV2.emit('executors');
                                    await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, false, true, [this.selectedExecutor], this.logTimeStamp, this.action);
                                    await this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), this.executor_name, this.selectedVersion, 'WORKFLOW', true, this.logTimeStamp, this.action);
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                    this.save = true;
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API TESTING', {
                                        info: 'Checking for testcases <br>Testcases found: 0',
                                        icon: 'fa fa-check-square-o',
                                        type: 'initial'
                                    }, this.logTimeStamp, this.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API TESTING', {
                                        info: 'Checking for testcases <br>Testcases found: 0',
                                        icon: 'fa fa-check-square-o',
                                        type: 'success'
                                    }, this.logTimeStamp, this.action);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documentation for the executor',
                                        type: 'initial',
                                        icon: 'fa fa-book'
                                    }, this.logTimeStamp, this.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documentation for the executor',
                                        type: 'success',
                                        icon: 'fa fa-book'
                                    }, this.logTimeStamp, this.action);
                                    await this.platform.delay(2000);
                                    this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'DONE', {
                                        info: '',
                                        type: 'success',
                                        icon: 'fa fa-check'
                                    }, this.logTimeStamp, this.action);
                                    this.editFlag = true;
                                    this.entity = this.executor_name;
                                    this.version = this.selectedVersion;
                                    this.getExecutor();
                                    this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                }, error => {
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                    this.platform.openSnackBar('We are working on the feature to deploy WorkFlow Builder APIs onto Cloud... Meanwhile, please validate your designtime use cases and let us know if you are interested in additional features.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                });
                            } else {
                                this.loading1 = false;
                                this.closeNonWSDialogBox();
                                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                                    info: 'Generating the API',
                                    icon: 'fa fa-code',
                                    type: 'fatal',
                                    description: errorExecutor && errorExecutor.message ? errorExecutor.message : 'Error while generating the API',
                                }, this.logTimeStamp, this.action);
                                if (!this.connection) {
                                    this.platform.handleErrorGracefully(errorExecutor, 'Error while generating the API');
                                }
                            }
                        });
                    }, error => {
                        this.loading1 = false;
                        this.closeNonWSDialogBox();
                        this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DEVELOPMENT', {
                            info: 'Generating process id from camunda',
                            icon: 'fa fa-code',
                            type: 'fatal',
                            description: error && error.message ? error.message : 'Error while getting process id from camunda',
                        }, this.logTimeStamp, this.action);
                        if (!this.connection) {
                            this.platform.handleErrorGracefully(error, 'Error while getting process id from camunda');
                        }
                    });

                    // });
                });
            } else {
                this.loading1 = false;
                this.closeNonWSDialogBox();
                this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DESIGN', {
                    info: 'Checking for all required fields',
                    type: 'fatal',
                    description: 'All required fields are not provided',
                    icon: 'fa fa-file-code-o'
                }, this.logTimeStamp, this.action);
            }
        } else {
            this.loading1 = false;
            this.closeNonWSDialogBox();
            this.platform.publishEventMessage(this.executor_name, this.selectedVersion, 'API DESIGN', {
                info: 'Checking for all required fields',
                type: 'fatal',
                description: 'Workflow API cannot be deployed without any diagram',
                icon: 'fa fa-file-code-o'
            }, this.logTimeStamp, this.action);
        }
    }

    runTests() {

        this.testLoading = true;
        this.confPost.testAPITestsuiteWithUsages(this.partner, this.account_id, this.partnerKey, {
            executor_name: this.orig_executor.executor_name,
            executor_version: this.orig_executor.executor_version
        }).subscribe(res => {
            this.testLoading = false;
            if (res) {
                this.testSuiteResponse = res;

                if (this.testSuiteResponse['testCaseResults'] !== undefined) {
                    const dialogRef = this.dialog.open(TestReportComponent, {
                        height: '80%',
                        width: '80%',
                        data: {
                            testSuitePayload: {name: this.testSuiteResponse.name},
                            testSuiteResponse: this.testSuiteResponse
                        }
                    });
                } else {
                    this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
                        duration: 7000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }

        }, error1 => {
            this.testLoading = false;
            this.platform.handleErrorGracefully(error1, 'Error while testing the API. Please try again after sometime.');

        });
    }

    async finishAPIDeployment(executor_name, executor_version, action, timeStamp, result = {completed: true, document: true}) {
        await this.platform.delay(500);
        if (result.completed) {
            if (result.document) {
                this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, timeStamp, action);
                await this.platform.delay(2000);
                this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_DOCUMENTATION, {
                    info: 'Regenerating Documents',
                    type: 'success',
                    icon: 'fa fa-book'
                }, timeStamp, action);
            }
            await this.platform.delay(1000);
            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.DONE, {
                info: '',
                type: 'success',
                icon: 'fa fa-check'
            }, timeStamp, action);

            this.getExecutor();

        }
        this.loading1 = false;
        this.closeNonWSDialogBox();

    }

    async revertExecutorChanges(executor, executor_name, executor_version, action, timeStamp) {
        this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
            info: 'Reverting changes to API',
            icon: 'fa fa-check-square-o',
            type: 'initial'
        }, timeStamp, action);
        this.confPost.updateApiExecutorForPartnerAccount(this.partner, this.account_id, executor['id'], executor).subscribe(async data => {

            if (this.selectedExecutor !== executor.executor_method_type) {
                await this.kongService.updateRouteWithMethods(this.partner, this.account_id, this.executor_name, this.selectedVersion, [executor.executor_method_type], timeStamp, action);
            }

            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'success'
            }, timeStamp, action);
            await this.finishAPIDeployment(executor_name, executor_version, action, timeStamp, {completed: false, document: false});
        }, error1 => {
            this.platform.publishEventMessage(executor_name, executor_version, environment.pubsubtitles.API_TESTING, {
                info: 'Reverting changes to API',
                icon: 'fa fa-check-square-o',
                type: 'fatal'
            }, timeStamp, action);
            this.finishAPIDeployment(executor_name, executor_version, action, timeStamp, {completed: false, document: false});
        });
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    manageProgress(target, showPanel) {
        if (this.progress <= target) {
            // this.showNextPanel = showPanel;
            // this.cfgSrv.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            //     let item = data;
            // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
            this.save = false;
            const apiKey = localStorage.getItem('apikey');
            const dialogRef = this.dialog.open(DialogComponent, {
                maxWidth: '95vw',
                data: {
                    type: 'bl',
                    save: true,
                    gatewayFullUrl: this.gatewayFullUrl,
                    Blocks: this.Blocks,
                    selectedVersion: this.selectedVersion,
                    showNextPanel: false,
                    partner: this.partner,
                    account: this.account_id,
                    selectedExecutor: this.selectedExecutor,
                    executor_name: this.executor_name,
                    apiKey: apiKey,
                    partnerKey: this.partnerKey
                }
            });
            dialogRef.afterClosed().subscribe(async result => {
                if (result === 'create') {
                    await this.router.navigateByUrl('/workflow');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (result === 'edit') {
                    this.router.navigateByUrl('/workflow?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                } else if (result === 'execute') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion);
                } else if (result === 'devex') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion + '&showDoc=true');
                }
            });
            // });
            // });
            this.ngOnDestroy();
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up Business Logic API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    // configureApiGateway() {
    //     const temp = localStorage.getItem('partner').split('-');
    //     const partnerShortCode = temp[temp.length - 1];
    //
    //     this.ratelimitingOrig = {
    //         'name': 'rate-limiting',
    //         'config': {'minute': 5},
    //         'protocols': ['http', 'https'],
    //         'enabled': true
    //     };
    //
    //     this.keyauthOrig = {
    //         'name': 'key-auth'
    //     };
    //     this.ipRestrictionOrig = {
    //         'name': 'ip-restriction',
    //         'enabled': false,
    //         'config': {
    //             'whitelist': ['127.0.0.1']
    //         }
    //     };
    //     this.cors = {
    //         'name': 'cors',
    //         'enabled': true,
    //         'config': {
    //             'methods': ['GET', 'PUT', 'POST', 'PATCH', 'DELETE', 'OPTIONS'],
    //             'exposed_headers': [],
    //             'max_age': 300,
    //             'headers': [],
    //             'origins': [
    //                 '*'
    //             ],
    //             'credentials': false,
    //             'preflight_continue': false
    //         }
    //     };
    //     this.acl = {
    //         'name': 'acl',
    //         'enabled': true,
    //         'config': {
    //             'whitelist': [partnerShortCode],
    //             'blacklist': null,
    //             'hide_groups_header': false
    //         }
    //     };
    //
    //     this.servicedata = {
    //         'name': this.partner + '-' + this.account_id + '-' + this.executor_name,
    //         'retries': 5,
    //         'protocol': 'https',
    //         'host': environment.apihostname,
    //         'port': 443,
    //         'path':  '/' + this.partner + '/' + this.account_id + '/' + this.selectedVersion + '/' + this.executor_name,
    //         'connect_timeout': 60000,
    //         'write_timeout': 60000,
    //         'read_timeout': 60000
    //     };
    //     this.kongService.createServiceToApiGateway(this.servicedata).subscribe(res => {
    //         Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'apigateway_services_create_success', 'INFO', 200, 'OK', '', this.servicedata, res, this.router.url)).then(resp => {
    //             const payloadToSend = {
    //                 actions: resp
    //             };
    //             this.apiGatewayListenerInstance.apiGatewayListener.emit({
    //                 type: 'audit',
    //                 id: localStorage.getItem('IdOfSession'),
    //                 payload: payloadToSend
    //             });
    //         });
    //         this.kongService.createRouteForAServiceToApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name, this.routepathdata).subscribe(route => {
    //             this.kongService.createPluginForServiceInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name, this.ratelimitingOrig).subscribe(ratelimitingplugin => {
    //                 this.kongService.createPluginForServiceInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name, this.keyauthOrig).subscribe(keyauthplugin => {
    //                     this.kongService.createPluginForRouteInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name + '-path', this.ratelimitingOrig).subscribe(ratelimiting1 => {
    //                         this.kongService.createPluginForRouteInApiGateway(this.partner + '-' + this.account_id + '-' + this.executor_name + '-path', this.keyauthOrig).subscribe(keyauth1 => {
    //                         });
    //                     });
    //                 });
    //             });
    //         });
    //     }, error => {
    //         Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'apigateway_services_create_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), this.servicedata, error, this.router.url)).then(resp => {
    //             const payloadToSend = {
    //                 actions: resp
    //             };
    //             this.apiGatewayListenerInstance.apiGatewayListener.emit({
    //                 type: 'audit',
    //                 id: localStorage.getItem('IdOfSession'),
    //                 payload: payloadToSend
    //             });
    //         });
    //     });
    // }
    generateExecutorAgain() {
        window.location.reload();
    }

    toggleExecutor1(ev) {
        if (ev === 'DELETE') {
            if (this.isToggleExpanded === true) {
                this.isToggleExpanded = false;
                $('.executorDefinition').slideToggle();
                $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
            }
        } else {
            if (this.isToggleExpanded === false) {
                this.isToggleExpanded = true;
                $('.executorDefinition').slideToggle();
                $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
            }
        }
    }

    toggleExecutor(ev) {
        $('.executorDefinition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    copyMessage(event) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(event.target).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    updateAttributes() {
        const that = this;
        this.attributeList.forEach((attr, index) => {
            if (attr[0].includes('Parameter') || attr[0].includes('Header')) {
                that.attributeList.splice(index, 1);
            }
        });
        this.headers.forEach((queryParam) => {
            if (queryParam.key !== '') {
                if (that.attributeList.findIndex(p => p[0] === 'Header.' + queryParam.key) === -1) {
                    that.attributeList.push(['Header.' + queryParam.key, 'Header.' + queryParam.key]);
                }
            }
        });
        this.queryParams.forEach((queryParam) => {
            if (queryParam.key !== '') {
                if (that.attributeList.findIndex(p => p[0] === 'Parameter.' + queryParam.key) === -1) {
                    that.attributeList.push(['Parameter.' + queryParam.key, 'Parameter.' + queryParam.key]);
                }
            }
        });
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
        BpmnInit.initialised = false;
    }

    getAPIs() {
        return BpmnInit.getAPIs();
    }

    openFileUploadDialog() {
        const dialogRef = this.dialog.open(ImportBpmnDialogComponent, {
            height: '60%',
            width: '40%'
        });
        dialogRef.afterClosed().subscribe(file => {
            if (file) {
                this.processFile(file);
            }
        });
    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.editFlag === false) {
            this.confPost.getAPIExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/workflow?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                }
            });
        }
    }

    show() {
        // alert('Hi');
    }

    onCreatingAPI(apiName, id) {
        BpmnInit.closeDialog(id);
        BpmnInit.refreshAPIs(apiName);
    }

    closeDialog(id) {
        BpmnInit.closeDialog(id);
        if (this.apiName && this.apiName !== '') {
            BpmnInit.refreshAPIs(this.apiName);
            this.apiName = '';
        }
        // BpmnInit.refreshAPIs('testworkflowreg3_v3');
    }

    checkForBlockly() {
        if (document.getElementById('createBusinessLogicAPI') && document.getElementById('createBusinessLogicAPI')['open']) {
            return true;
        }
        return false;
    }

    importFromS3() {
        const dialogRef = this.dialog.open(ImportFromS3Component, {
            data: {file: ''},
            height: '70%',
            width: '80%'
        });
        dialogRef.afterClosed().subscribe(file => {
            if (file) {
                this.processFile(file);
            }
        });
    }

    closeExecutionLogs() {
        this.isExecute = false;
        $('.djs-palette').removeClass('two-column');
        $('.canvas').removeClass('dock');
        $('.properties-panel-parent').removeClass('dock');
        $('.djs-palette').removeClass('dock-tools');
    }

    drag(ev, serviceProvider) {
        // $('#drag').draggable();
        const temp = {
            serviceProvider: serviceProvider,
        };
        ev.dataTransfer.setData('data', JSON.stringify(temp));
    }

    drop(ev) {
        ev.preventDefault();
        const data = JSON.parse(ev.dataTransfer.getData('data'));

        const container = document.getElementById('js-drop-zone');

        const modeler = BpmnInit.bpmnModeler;
        // const modeler = new Modeler({
        //     container,
        //     keyboard: {
        //         bindTo: document
        //     }
        // });

        const canvas = modeler.get('canvas');
        const elementFactory = modeler.get('elementFactory');


        canvas.zoom('fit-viewport');

        const task = elementFactory.createBpmnElement('shape', {
            type: 'bpmn:ServiceTask',
            serviceProvider: JSON.stringify(data),
            x: ev.offsetX,
            y: ev.clientY - 100,
            order: {
                level: 5
            }
        });


        const root = canvas.getRootElement();

        const shape = canvas.addShape(task, root);

        const image = data.serviceProvider.image;
        const overlays = modeler.get('overlays');
        const id = shape.id;
        overlays.add(task, {
            html: `<div lass="img-overlay">
                <img id="${id}" height="40" width="70" src="${image}">
              </div>`,
            position: {
                left: 12,
                top: -41
            }
        });

        BpmnInit.formConfigs.serviceTask.fieldEls['logo'] = document.getElementById(id);

//         const xml = `<?xml version="1.0" encoding="UTF-8"?>
// <bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn" exporter="Camunda Modeler" exporterVersion="3.3.5">
//   <bpmn:process id="Process_1" isExecutable="true">
//   </bpmn:process>
//   <bpmndi:BPMNDiagram id="BPMNDiagram_1">
//     <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
//     </bpmndi:BPMNPlane>
//   </bpmndi:BPMNDiagram>
// </bpmn:definitions>`;
//
//         modeler.importXML(xml, err => {
//             if (err) {
//                 console.error(err);
//             }
//
//             const canvas = modeler.get('js-canvas');
//             const elementFactory = modeler.get('elementFactory');
//
//             canvas.zoom('fit-viewport');
//
//             const task = elementFactory.createBpmnElement('shape', {
//                 type: 'bpmn:Task',
//                 x: 350,
//                 y: 100
//             });
//
//             const root = canvas.getRootElement();
//
//             canvas.addShape(task, root);
//         });

    }

    getIconForExecutor (type) {
        if (type === 'SQLQUERY' || type === 'PLSQL' || type === 'DATATRANSFORMATION') {
            return 'fa fa-database';
        } else if (type === 'API') {
            return 'fa fa-table';
        } else if (type === 'TESTSUITE') {
            return 'fa fa-check-circle-o';
        } else if (type === 'WORKFLOW') {
            return 'fa fa-sitemap';
        } else if (type === 'BUSINESSLOGIC') {
            return 'fa fa-link';
        } else if (type === 'THIRDPARTY') {
            return 'fa fa-registered';
        } else {
            return 'fa fa-server';
        }
    }

    getCustomAPIList() {
        if (BpmnInit && BpmnApiHelper && BpmnApiHelper.apiList && BpmnInit.formConfigs && BpmnInit.formConfigs.serviceTask) {
            const apiList = BpmnApiHelper.apiList ? BpmnApiHelper.apiList.length > 1 ?
                BpmnApiHelper.apiList.slice(1, BpmnApiHelper.apiList.length) : [] : [];
            const config = BpmnInit.formConfigs.serviceTask;
            if (config && config.element && config.element.serviceProvider) {
                const serviceProviderObj = JSON.parse(config.element.serviceProvider);
                const serviceProviderProducer = serviceProviderObj.serviceProvider.producer;

                const newArray = apiList.filter(function (el) {
                    return el.name.startsWith(serviceProviderProducer + ':');
                });

                for (const val of newArray) {
                    val['logo'] = serviceProviderObj.serviceProvider.image;
                    val['logoType'] = 'image';
                }
                return this.filterAPIBasedOnSearch(newArray);
            } else {
                for (const val of apiList) {
                    val['logo'] = this.getIconForExecutor(val ? val.apiResult ? val.apiResult.executor_type : '' : '');
                    val['logoType'] = 'fa-icon';
                }
                return this.filterAPIBasedOnSearch(apiList);
            }

            return this.filterAPIBasedOnSearch(apiList);
        } else {
            return [];
        }
    }

    filterAPIBasedOnSearch(apilist) {
        let search = this.apiSearchInputCrtl.value;
        if (!search) {
            return apilist;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        return apilist.filter(bank => bank.name.toLowerCase().indexOf(search) > -1);
    }

    updateAPIforServiceTask(selection) {
        this.apiList = BpmnApiHelper.apiList;
        BpmnInit.formConfigs.serviceTask.fieldEls.apiName.value = selection.value;
        BpmnFormHelper.ServiceTaskcbUpdateMapping(BpmnInit.formConfigs.serviceTask, BpmnInit.bpmnFormGlobals)
    }

    createPaddingRight() {
        document.getElementById('view:workflow_editor').style.paddingRight = '400px';
    }

    removePaddingRight() {
        document.getElementById('view:workflow_editor').style.paddingRight = '0px';
    }

    getWorkflowTourSteps(): Array<TourStep>{
        let steps: TourStep[] = [];
        steps.push({
            title: this.platform.getProperty('GT_WORLFLOW_INTRO_TITLE'),
            content: this.platform.getProperty('GT_WORLFLOW_INTRO_CONTENT'),
        },
        {
            title: this.platform.getProperty('GT_WORLFLOW_API_NAME_TITLE'),
            selector: '.tour-workflow-api-name',
            content: this.platform.getProperty('GT_WORLFLOW_API_NAME_CONTENT'),
            orientation: Orientation.Right
        },
        {
            title: this.platform.getProperty('GT_WORLFLOW_API_VERSION_TITLE'),
            selector: '.tour-workflow-api-version',
            content: this.platform.getProperty('GT_WORLFLOW_API_VERSION_CONTENT'),
            orientation: Orientation.Right
        },
        {
            title: this.platform.getProperty('GT_WORLFLOW_API_METHOD_TITLE'),
            selector: '.tour-workflow-api-method',
            content: this.platform.getProperty('GT_WORLFLOW_API_METHOD_CONTENT'),
            orientation: Orientation.Right
        },
        {
            title: this.platform.getProperty('GT_WORLFLOW_API_CATEGORY_TITLE'),
            selector: '.tour-workflow-api-category',
            content: this.platform.getProperty('GT_WORLFLOW_API_CATEGORY_CONTENT'),
            orientation: Orientation.Right
        },
        {
            title: this.platform.getProperty('ADD_WORLFLOW_DIAGRAM_TITLE'),
            selector: '.tour-workflow-add-diagram',
            content: this.platform.getProperty('ADD_WORLFLOW_DIAGRAM_CONTENT'),
            orientation: Orientation.Bottom,
            action: (() => {this.blankDiagram()})
        },
        {
            title: this.platform.getProperty('ADD_WORLFLOW_BLANK_DIAGRAM_TITLE'),
            selector: '.tour-workflow-blank-diagram',
            content: this.platform.getProperty('ADD_WORLFLOW_BLANK_DIAGRAM_CONTENT'),
            orientation: Orientation.Left,
        },
        {
            title: this.platform.getProperty('ADD_WORLFLOW_SUBSCRIBED_TITLE'),
            selector: '.tour-workflow-subscribed',
            content: this.platform.getProperty('ADD_WORLFLOW_SUBSCRIBED_CONTENT'),
            orientation: Orientation.Right
        },
//         {
//             title: this.platform.getProperty('ADD_WORLFLOW_COMPONENT_PALETTE_TITLE'),
//             selector: '.tour-workflow-component-palette',
//             content: this.platform.getProperty('ADD_WORLFLOW_COMPONENT_PALETTE_CONTENT'),
//             orientation: Orientation.Right
//         },
        {
            title: this.platform.getProperty('ET_WORFLOW_ITEM_DETAILS_TITLE'),
            selector: '.tour-workflow-item-details',
            content: this.platform.getProperty('ET_WORFLOW_ITEM_DETAILS_CONTENT'),
            orientation: Orientation.Left
        },
        {
            title: this.platform.getProperty('DD_WORLFLOW_DIAGRAM_TITLE'),
            selector: '.tour-workflow-download',
            content: this.platform.getProperty('DD_WORLFLOW_DIAGRAM_CONTENT'),
            orientation: Orientation.Bottom
        },
        {
            title: this.platform.getProperty('SV_WORLFLOW_API_TITLE'),
            selector: '.tour-workflow-save',
            content: this.platform.getProperty('SV_WORLFLOW_API_CONTENT'),
            orientation: Orientation.Bottom
        },
        {
            title: this.platform.getProperty('EX_WORLFLOW_API_TITLE'),
            selector: '.tour-workflow-execute',
            content: this.platform.getProperty('EX_WORLFLOW_API_CONTENT'),
            orientation: Orientation.Bottom
        },
        {
            title: this.platform.getProperty('DP_WORLFLOW_API_TITLE'),
            selector: '.tour-workflow-deploy',
            content: this.platform.getProperty('DP_WORLFLOW_API_CONTENT'),
            orientation: Orientation.Left
        });

        return steps;
    }
}

@Component({
    selector: 'app-exportBpmnToS3',
    templateUrl: './export-to-s3.html',
    styleUrls: ['./workfloweditor.component.scss']
})
export class ExportBpmnToS3Component {
    constructor(
        public dialogRef: MatDialogRef<ExportBpmnToS3Component>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    submit() {
        this.dialogRef.close(this.data.name);
    }

    closeDialog() {
        this.dialogRef.close();
    }


}

@Component({
    selector: 'app-importFromS3',
    templateUrl: './import-from-s3.html',
    styleUrls: ['./workfloweditor.component.scss']
})
export class ImportFromS3Component {
    constructor(
        public dialogRef: MatDialogRef<ExportBpmnToS3Component>,
        @Inject(MAT_DIALOG_DATA) public data: any, public confPost: ConfService) {
    }

    partner = localStorage.getItem('partner');

    submit() {
        this.dialogRef.close(this.data.file);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    async importFileFromS3(file) {
        if (file) {
            let payload = {s3URLs: []};
            payload.s3URLs.push(file.downloadUri);

            this.confPost.getFilesFromS3(this.partner, payload).subscribe((data) => {
                let fileContent: any;
                fileContent = data;

                const byteCharacters = atob(fileContent[0].content);
                let byteNumbers = [];
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers.push(byteCharacters.charCodeAt(i));
                }
                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], {type: 'application/octet-stream'});

                const createdFile = new File([blob], file.path);
                this.dialogRef.close(createdFile);
            });
        }

    }

}
